<script setup lang="ts">
import { ref } from 'vue'

const svgRef = ref<SVGSVGElement | null>(null)
let animating = false

const MIN_H = 24, MAX_H = 90, CENTER = 60.5
const REST = [30.8, 64.9, 88, 59.4, 30.8, 59.4] as const
const BAR_PHASE = [0, 1, 2, 3, 4, 5].map(i => i / 6 * Math.PI * 2)
const PHASE_OFFSET = -0.523
const DURATION = 1200

function waveHeight(phase: number) {
  return MIN_H + (MAX_H - MIN_H) * (Math.sin(phase) + 1) / 2
}

function startWave() {
  const svg = svgRef.value
  if (!svg || animating) return
  animating = true
  const bars = svg.querySelectorAll('.bar')
  const start = performance.now()

  function tick(now: number) {
    const t = Math.min((now - start) / DURATION, 1)
    const advance = t * Math.PI * 2

    let env: number
    if (t < 0.15) env = t / 0.15
    else if (t > 0.85) env = (1 - t) / 0.15
    else env = 1
    env = env * env * (3 - 2 * env)

    bars.forEach((bar, i) => {
      const restH = REST[i] as number
      const phase = PHASE_OFFSET + (BAR_PHASE[i] as number) + advance
      const h = restH + (waveHeight(phase) - restH) * env
      bar.setAttribute('y', String(CENTER - h / 2))
      bar.setAttribute('height', String(h))
    })

    if (t < 1) {
      requestAnimationFrame(tick)
    } else {
      bars.forEach((bar, i) => {
        const restH = REST[i] as number
        bar.setAttribute('y', String(CENTER - restH / 2))
        bar.setAttribute('height', String(restH))
      })
      animating = false
    }
  }
  requestAnimationFrame(tick)
}

defineExpose({ startWave })
</script>

<template>
  <svg
    ref="svgRef"
    class="logo-icon-svg"
    viewBox="0 0 168 121"
    xmlns="http://www.w3.org/2000/svg"
    @mouseenter="startWave"
  >
    <rect class="bar" x="0"     y="45.1"  width="16.6" height="30.8" rx="8.3"  fill="#001F30" />
    <rect class="bar" x="27.2"  y="28.05" width="22.1" height="64.9" rx="11"   fill="#00A7FF" />
    <rect class="bar" x="61"    y="16.5"  width="16.6" height="88"   rx="8.3"  fill="#001F30" />
    <rect class="bar" x="90.9"  y="30.8"  width="16.6" height="59.4" rx="8.3"  fill="#001F30" />
    <rect class="bar" x="121.4" y="45.1"  width="16.6" height="30.8" rx="8.3"  fill="#001F30" />
    <rect class="bar" x="151.4" y="30.8"  width="16.6" height="59.4" rx="8.3"  fill="#001F30" />
  </svg>
</template>

<style scoped>
.logo-icon-svg {
  display: block;
}
</style>
